module.exports = __webpack_public_path__ + "static/img/nav_bg_fix.f9677aff.png";